import { createSlice } from "@reduxjs/toolkit";
import {
  addEducationMonitoring,
  getAcademicYears,
  getGeneralEducationMonitoring,
  getSubjects,
  getAcademicLevels,
  getUniversitiesMonitoring,
  addUniversityMonitoring,
  getUniversities,
} from "../actions/monitoring.actions";

const initialState = {
  TotalUniversityMonitorings: 0 as number,
  TotalGeneralMonitorings: 0 as number,
  monitorings: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  subjects: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  addEducationalMonitoring: {
    loading: false,
    error: null as unknown | null,
    data: {} as any,
  },
  academicYears: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  scholarshipsSchool: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  academicLevels: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  universityMonitorings: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  addUniversityMonitoring: {
    loading: false,
    error: null as unknown | null,
    data: {} as any,
  },
  universities: [] as any,
  loading: false,
  error: null as unknown | null,
};
export const monitoringSlice = createSlice({
  name: "monitoring",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get general education monitoring builder
    builder.addCase(getGeneralEducationMonitoring.pending, (state) => {
      state.monitorings.loading = true;
    });
    builder.addCase(
      getGeneralEducationMonitoring.fulfilled,
      (state, action) => {
        state.monitorings.data = action.payload.data;
        state.TotalGeneralMonitorings = action.payload.total_pages;
        state.monitorings.loading = false;
      }
    );
    builder.addCase(getGeneralEducationMonitoring.rejected, (state, action) => {
      state.TotalGeneralMonitorings = 0;

      state.monitorings.data = [];
      state.monitorings.loading = false;
      state.error = action.payload;
    });

    //getSubjects
    builder.addCase(getSubjects.pending, (state) => {
      state.subjects.loading = true;
    });
    builder.addCase(getSubjects.fulfilled, (state, action) => {
      state.subjects.data = action.payload;
      state.subjects.loading = false;
    });
    builder.addCase(getSubjects.rejected, (state, action) => {
      state.subjects.data = [];
      state.subjects.loading = false;
      state.error = action.payload;
    });

    //getAcademicYears
    builder.addCase(getAcademicYears.pending, (state) => {
      state.academicYears.loading = true;
    });
    builder.addCase(getAcademicYears.fulfilled, (state, action) => {
      state.academicYears.data = action.payload;
      state.academicYears.loading = false;
    });
    builder.addCase(getAcademicYears.rejected, (state, action) => {
      state.academicYears.data = [];
      state.academicYears.loading = false;
      state.error = action.payload;
    });
    //add education monitoring
    builder.addCase(addEducationMonitoring.pending, (state) => {
      state.addEducationalMonitoring.loading = true;
    });
    builder.addCase(addEducationMonitoring.fulfilled, (state, action) => {
      state.addEducationalMonitoring.data = action.payload;
      state.addEducationalMonitoring.loading = false;
    });
    builder.addCase(addEducationMonitoring.rejected, (state, action) => {
      state.addEducationalMonitoring.data = {};
      state.addEducationalMonitoring.loading = false;
      state.error = action.payload;
    });
    //getAcademicLevels
    builder.addCase(getAcademicLevels.pending, (state) => {
      state.academicLevels.loading = true;
    });
    builder.addCase(getAcademicLevels.fulfilled, (state, action) => {
      state.academicLevels.data = action.payload;
      state.academicLevels.loading = false;
    });
    builder.addCase(getAcademicLevels.rejected, (state, action) => {
      state.academicLevels.data = [];
      state.academicLevels.loading = false;
      state.error = action.payload;
    });
    //get universities monitoring
    builder.addCase(getUniversitiesMonitoring.pending, (state) => {
      state.universityMonitorings.loading = true;
    });
    builder.addCase(getUniversitiesMonitoring.fulfilled, (state, action) => {
      state.universityMonitorings.data = action.payload.data;
      state.TotalUniversityMonitorings = action.payload.total_pages;
      state.universityMonitorings.loading = false;
    });
    builder.addCase(getUniversitiesMonitoring.rejected, (state, action) => {
      state.TotalUniversityMonitorings = 0;
      state.universityMonitorings.data = [];
      state.universityMonitorings.loading = false;
      state.error = action.payload;
    });
    // add university monitoring
    builder.addCase(addUniversityMonitoring.pending, (state) => {
      state.addUniversityMonitoring.loading = true;
    });
    builder.addCase(addUniversityMonitoring.fulfilled, (state, action) => {
      state.addUniversityMonitoring.data = action.payload;
      state.addUniversityMonitoring.loading = false;
    });
    builder.addCase(addUniversityMonitoring.rejected, (state, action) => {
      state.addUniversityMonitoring.data = {};
      state.addUniversityMonitoring.loading = false;
      state.error = action.payload;
    });
    // get universities

    builder.addCase(getUniversities.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUniversities.fulfilled, (state, action) => {
      state.universities = action.payload;
      state.loading = false;
    });
    builder.addCase(getUniversities.rejected, (state, action) => {
      state.universities = [];
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default monitoringSlice.reducer;
